var map = {
	"./en/Partners_Kalozoumis": [
		"5dc7",
		"chunk-5ae94425"
	],
	"./gr/Partners_Kalozoumis": [
		"d3cb",
		"chunk-b8964a3c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a646";
module.exports = webpackAsyncContext;